import { WIDTH_STOP_BRAND } from '..';
import { CheckButton } from '../../../../components/Basic/Buttons';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import styles from '../styles.module.scss';

const StopBrandsLine = ({
  item = {},
  productsSelect = {},
  changeProductSelect = (_) => _,
  onChange = () => { },
}) => {
  return (
    <>
      <TableLine key={`${item._id}`} select={productsSelect[item._id]} styles={styles.table_line}>
        {/*      <TableCell width={WIDTH_STOP_BRAND[0]}>
          <CheckButton
            checked={productsSelect[item._id]}
            //onSelect={() => console.log(product.artnumber)}

            onSelect={() => changeProductSelect(item._id)}
          />
        </TableCell> */}

        <TableCell width={WIDTH_STOP_BRAND[1]} fontSize="14px">
          {item.name}
        </TableCell>
        <TableCell width={WIDTH_STOP_BRAND[2]} fontSize="14px" center={true}>
          <CheckButton
            checked={item.stop_mp?.ozon}
            onSelect={() => {
              onChange(item.name, 'stop_ozon', !item.stop_mp?.ozon);
            }}
          />
        </TableCell>
        <TableCell width={WIDTH_STOP_BRAND[2]} fontSize="14px" center={true}>
          <CheckButton
            checked={item.stop_mp?.wb}
            onSelect={() => {
              onChange(item.name, 'stop_wb', !item.stop_mp?.wb);
            }}
          />
        </TableCell>
        <TableCell width={WIDTH_STOP_BRAND[2]} fontSize="14px" center={true}>
          <CheckButton
            checked={item.stop_mp?.yandex}
            onSelect={() => {
              onChange(item.name, 'stop_yandex', !item.stop_mp?.yandex);
            }}
          />
        </TableCell>
      </TableLine>
    </>
  );
};

export default StopBrandsLine;
